import textOverflow from '@/components/text/overflow'

function renderPlatformTitle(h) {
  const title = this.globalSettings?.frontend?.title
  if (title) {
    return h(
      textOverflow,
      {
        class: 'title-layout__title',
        props: {
          value: title
        }
      }
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: 'title-layout__header'
    },
    [
      this.value,
      renderPlatformTitle.call(this, h)
    ]
  )
}
